import {ModalWrapper} from "reoverlay";
import React, {useState} from "react";
import TextField from "../inputs/TextField";
import Button from "../../newComponents/button/Button";
import billTypes from "../../../tools/defaults/tosan/billTypes";
const EditBillModal=({billInfo,type,onEdit,onClose})=>{
    const [billLabel, setBillLabel] = useState(billInfo.alias);
    const handleChangeLabel = (e) => {
        setBillLabel(e.target.value)
    }
    const handleEdit = () => {
        const data = {
            id: billInfo.id,
            alias: billLabel,
        }
        onEdit(data)
    }
    const handleClose = () => {

        onClose()
    }
    return <ModalWrapper animation="slideUp" contentContainerClassName="w-11/12 md:w-5/12 fixed w-full bottom-0 bg-gray-50 lg:w-4/12 p-5 rounded-t-lg" >
        <div className="edit-bill-modal-wrapper">
            <div  className="w-full">
                <div className="w-full  py-3  flex flex-col justify-center items-center  mb-2 border-b"><h1
                    className="font-black text-gray-800">ویرایش قبض</h1></div>
                <div className="grid grid cols-1  mb-5 ">
                    <TextField inputClassName='rounded' label={billTypes[type].parameterLabel} defaultValue={billInfo.bill_main_param}
                               disabled={true}/>
                    <TextField inputClassName='rounded' className='mt-3 ' label="نام مستعار" value={billLabel}
                               onChange={handleChangeLabel}/>
                </div>
                <div className="grid  pt-5  border-t   grid-cols-2 gap-2">
                    <Button rounded="rounded" onClick={handleClose} theme="link">بستن</Button>
                    <Button rounded="rounded" onClick={handleEdit} theme="primary">ویرایش </Button>

                </div>
            </div>
        </div>
          </ModalWrapper>
}
export default EditBillModal;